export default class MobileNavigation {
    constructor() {
        this.navigationWrapper = document.querySelector('.js-navigation');
        this.navigation = document.querySelector('.js-mobile-navigation');
        this.navigationBtn = document.querySelector('.js-mobile-nav-btn');
        this.isOpened = false;

        if (!this.navigationWrapper) {
            return;
        }

        this.init();
    }

    init() {
        // mobile-opened

        this.navigationBtn.addEventListener('click', () => {
            if (this.isOpened) {
                this.navClose();

                return;
            }

            this.navOpen();
        });
    }

    navOpen() {
        this.isOpened = true;
        this.navigationWrapper.classList.add('mobile-opened');
        this.navigation.classList.add('is-opened');
        this.navigationBtn.classList.add('is-opened');
    }

    navClose() {
        this.isOpened = false;
        this.navigationWrapper.classList.remove('mobile-opened');
        this.navigation.classList.remove('is-opened');
        this.navigationBtn.classList.remove('is-opened');
    }
}
